import { Badge, Box, Button, Center, Flex, Heading, Icon, Image, Spacer, Text } from '@chakra-ui/react';
import { BsCart4 } from 'react-icons/bs';
import { HiCheckCircle } from 'react-icons/hi2';
import { MdRoom } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import { trackRemoveFromCart } from '../../../helper/utils/eventTrackGA';
import { formattedCurrency } from '../../../helper/utils/formattedCurrency';
import { formattedDate3 } from '../../../helper/utils/formattedDate';
import { isEmptyObject } from '../../../helper/utils/isEmptyObject';
import { urlNavigate } from '../../../helper/utils/navigation';
import { isCartContainRecurring, isItemContainRecurring } from '../../../redux/utils/menuItem';
import useCartDatas from '../hooks/useCartDatas';
import useOnlineSales from '../hooks/useOnlineSales';
import ProductItemQty from './ProductItemQty';

export default function ProductCarts() {
    const { cart, navigate, getSubtotal, getTax, getGrandtotal, handleDeleteItemCart, handleUpdateItemCart } = useCartDatas();
    const { getMinQty, getMaxQty } = useOnlineSales();

    const location = useLocation();
    const splittedPath = location.pathname.split('/');
    const lastPath = splittedPath[splittedPath.length - 1];
    const isAddons = lastPath == 'add-ons';
    const isCheckout = lastPath == 'checkout' || lastPath == 'payment';
    const isSubscription = isCartContainRecurring(cart);

    return (
        <Box id='cart' key='cart' bg='white' rounded='xl' border='1px' borderColor='secondary.100' p={5} h='max-content' boxShadow='10px 10px 30px 1px rgba(128, 128, 128, 0.075)'>
            <Box>
                <Heading fontSize={{ base: 'xl', md: '2xl' }} fontWeight={500}>
                    Your Orders
                </Heading>
            </Box>
            <Box w='full' my={7}>
                {cart?.map((item, index) => {
                    const { menuName = '', timeSlot = '', duration = '', qty = 0, price = 0, imageUrl = '', date = '' } = item;
                    const isMembership = item['productType'] && item['productType'] == 'membership';
                    const isParty = (item['menuType'] || '').toString().trim().toLowerCase() === 'party';
                    const isSubs = isItemContainRecurring(item['combo'] || []) || isMembership || isParty;
                    const isAddons = item['isMenuAddOns'] || false;
                    const isCanDelete = item['isCanDelete'] !== undefined ? item['isCanDelete'] : true;
                    const disableQtyBtn = isItemContainRecurring(item['combo'] || []) || isParty || !isCanDelete;

                    const combo = item['combo'] || [];
                    const rooms = item['rooms'] || [];

                    return (
                        <Box w='full' py={isAddons ? 2 : 4} pb={isAddons ? 0 : 4} pl={isAddons ? 2 : 0} borderLeft={isAddons ? '1px' : 'none'} borderLeftColor='gray.200'>
                            {!isAddons && (
                                <Box mb={5}>
                                    <Flex alignItems='center' gap={2}>
                                        {
                                            <Badge bg='secondary.800' px={3} py={1} rounded='md' variant='solid'>
                                                {formattedDate3(date)}
                                            </Badge>
                                        }
                                        {!isEmptyObject(timeSlot) && isParty && (
                                            <Badge bg='secondary.200' color='secondary.800' px={3} py={1} rounded='md' variant='solid'>
                                                {timeSlot['sessionName']} ({duration} HRS)
                                            </Badge>
                                        )}

                                        {isSubs && (
                                            <Badge bg='tertiary.200' color='tertiary.800' border='1px' borderColor='tertiary.600' px={3} py={1} rounded='md' variant='solid'>
                                                {isMembership ? 'membership' : isParty ? 'party' : 'subscription'}
                                            </Badge>
                                        )}
                                    </Flex>
                                </Box>
                            )}

                            <Box w='full'>
                                <Flex w='full' alignItems='start' justifyContent='start' gap={2}>
                                    <Box>
                                        {String(imageUrl).trim() !== '' && (
                                            <Center w='65px' h='65px' rounded='md' overflow='hidden'>
                                                <Image w='full' h='full' fit='contain' src={imageUrl} />
                                            </Center>
                                        )}
                                    </Box>
                                    <Box w='full'>
                                        <Box>
                                            <Text fontSize='15px' casing='uppercase' noOfLines={2} lineHeight={1.3} fontWeight={600}>
                                                {menuName}
                                            </Text>
                                            <Flex mt={2} w='full' alignItems='center' justifyContent='start' gap={3}>
                                                <Text fontSize='13px' fontWeight={800}>
                                                    {qty} x {formattedCurrency(price)}
                                                </Text>
                                                <Spacer />
                                                <Text fontSize='13px' fontWeight={800}>
                                                    {formattedCurrency(qty * price)}
                                                </Text>
                                            </Flex>
                                            <Box mt={2}>
                                                <Flex w='full' alignItems='center' gap={2} flexWrap='wrap'>
                                                    {rooms?.map((val, index) => {
                                                        return (
                                                            <Flex key={index} w='max-content' alignItems='center' justifyContent='start' gap={1} bg='orange.100' rounded='md' px={2} py={1}>
                                                                <Icon as={MdRoom} color='orange.500' />
                                                                <Text fontSize='12px' fontWeight={600} color='orange.800' casing='capitalize'>
                                                                    {val['roomName']}
                                                                </Text>
                                                                <Spacer />
                                                            </Flex>
                                                        );
                                                    })}
                                                </Flex>
                                            </Box>

                                            <Box w='full' ml={1}>
                                                {combo?.map((val, index) => {
                                                    const qty = parseFloat(val['qty'] || '0');
                                                    return (
                                                        <Flex key={index} mt={2} w='full' alignItems='center' justifyContent='start' gap={1}>
                                                            <Icon as={HiCheckCircle} color='green' />
                                                            <Text fontSize='12px' fontWeight={600} color='green.400' casing='capitalize'>
                                                                {qty}x {val['menuName']}
                                                            </Text>
                                                            <Spacer />
                                                            {/* <Text fontSize='13px' fontWeight={600}>
                                                                {formattedCurrency(qty * price)}
                                                            </Text> */}
                                                        </Flex>
                                                    );
                                                })}
                                            </Box>
                                        </Box>
                                        {!isCheckout && (
                                            <Box mt={disableQtyBtn ? 0 : 3}>
                                                <ProductItemQty
                                                    // max={parseInt(timeSlot['capacity'] || '10')}
                                                    isDisabled={disableQtyBtn}
                                                    showControlQty={isAddons ? !disableQtyBtn : true}
                                                    showInputQty={isAddons ? !disableQtyBtn : true}
                                                    canDelete={isCanDelete}
                                                    min={getMinQty(item)}
                                                    max={getMaxQty(item)}
                                                    onDeleteItem={() => {
                                                        const payload = {
                                                            product: item,
                                                            timeSlot: item['timeSlot'],
                                                            date: item['date'],
                                                            qty: 0,
                                                            id: item['id'],
                                                            isAddons,
                                                        };

                                                        const product = payload['product'] || {};
                                                        const price = parseFloat(product['basePrice'] || 0);
                                                        const value = price * qty;

                                                        const trackPayload = {
                                                            value: value,
                                                            currency: 'IDR',
                                                            items: [
                                                                {
                                                                    item_id: product['menuCode'] || '',
                                                                    item_name: product['menuName'] || '',
                                                                    item_category: product['cateCode'] || '',
                                                                    price: +(product['basePrice'] || 0),
                                                                    quantity: qty,
                                                                },
                                                            ],
                                                        };

                                                        trackRemoveFromCart(trackPayload);
                                                        handleDeleteItemCart(payload);
                                                    }}
                                                    defaultValue={qty}
                                                    onChangeQty={(value) => {
                                                        const payload = {
                                                            product: item,
                                                            timeSlot: item['timeSlot'],
                                                            date: item['date'],
                                                            qty: value,
                                                            id: item['id'],
                                                        };

                                                        if (value > 0) {
                                                            handleUpdateItemCart(payload);
                                                            return;
                                                        }

                                                        if (value < 1) {
                                                            handleDeleteItemCart(payload);
                                                            return;
                                                        }

                                                        return;
                                                    }}
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                </Flex>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
            {cart.length == 0 && (
                <Box w='full' py={5}>
                    <Center w='full' h='full' flexDirection='column' gap={5}>
                        <Icon fontSize='30px' color='secondary' as={BsCart4} />
                        <Text textAlign='center' color='secondary'>
                            Your cart is empty. Add some items to get started
                        </Text>
                    </Center>
                </Box>
            )}

            {cart.length > 0 && (
                <Box w='full' my={8}>
                    <Flex w='full' alignItems='center' justifyContent='space-between'>
                        <Text textAlign='start'>Subtotal</Text>
                        <Text textAlign='end' fontWeight={600} fontSize='sm'>
                            {formattedCurrency(getSubtotal())}
                        </Text>
                    </Flex>

                    <Flex w='full' alignItems='center' justifyContent='space-between'>
                        <Text textAlign='start' fontStyle='italic' fontSize='sm'>
                            * All price already include tax
                        </Text>
                    </Flex>

                    <Flex mt={3} w='full' alignItems='center' justifyContent='space-between'>
                        <Text textAlign='start' fontWeight={800} fontSize='lg'>
                            Total (inc. tax)
                        </Text>
                        <Text textAlign='end' fontWeight={800} fontSize='lg'>
                            {formattedCurrency(getGrandtotal())}
                        </Text>
                    </Flex>
                </Box>
            )}

            {cart.length > 0 && (
                <Box w='full'>
                    {isCheckout || (
                        <Button
                            position={{ base: 'sticky', md: 'relative' }}
                            bottom={0}
                            w='full'
                            p={7}
                            variant='solid'
                            colorScheme='green'
                            leftIcon={isAddons ? null : <BsCart4 />}
                            onClick={() => {
                                if (isAddons || isSubscription) {
                                    navigate(`${urlNavigate('online-sales', 'checkout')}`);

                                    return;
                                }

                                navigate(`${urlNavigate('online-sales', 'add-ons')}`);
                            }}>
                            <Text fontWeight={500}>Continue</Text>
                        </Button>
                    )}
                </Box>
            )}
        </Box>
    );
}
